// Libs
import _map from 'lodash/map'
import _filter from 'lodash/filter'
import _find from 'lodash/find'
import _has from 'lodash/has'
import _forEach from 'lodash/forEach'
import { createSelector } from 'reselect'
import { featureEach } from '@turf/meta'
import area from '@turf/area'
import convert from 'convert-units'

// Selectors
import jobs$ from './jobs'
import samplingPoints$ from './samplingPoints'
import grids$ from 'hfty-grid/src/selectors/grids'
import { supplies$ } from 'hfty-supplies/src'

// Exports
export default createSelector(
  [
    jobs$, samplingPoints$, grids$, supplies$,
  ],
  function (jobs: Array, samplingPoints: Array, grids: Array, supplies: Array) {
    let testableJobs = _filter(jobs, {status: 'Order Test'})
    testableJobs = _map(testableJobs, function (currentJob) {
      const job = { ...currentJob }
      job['samplingPoints'] = _filter(samplingPoints, {job: job.id}).length
      let grid = _find(grids, {job: job.id})
      if (grid) {
        grid = JSON.parse(grid.grid)

        let gridSizeObj = {}
        featureEach(grid, function (currentFeature) {
          let featureArea = convert(area(currentFeature)).from('m2').to('ac')
          if (!_has(gridSizeObj, currentFeature.properties.size)) {
            gridSizeObj = {
              ...gridSizeObj,
              [currentFeature.properties.size]: 0,
            }
          }
          gridSizeObj[currentFeature.properties.size] += featureArea
        })

        let jobArea = 0
        let price = 0
        job['supplies'] = []
        _forEach(gridSizeObj, function (num, key) {
          const supply = _find(supplies, {notes: key.toString()})
          const ceilArea = Math.ceil(num)
          jobArea += ceilArea
          price += ceilArea * supply.base_price
          job['supplies'].push({
            supply: supply.id,
            quantity: ceilArea,
            cost: price,
          })
        })
        job['price'] = price < 25 ? 25 : price
        job['area'] = jobArea
      }
      return job
    })

    return _filter(testableJobs, (job) => {
      return job.price && job.area
    })
  }
)
